import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, getStoredLocale } from './constants/locales';

const translationPath = `${import.meta.env.BASE_URL}locales/{{lng}}/translation.json`;
const previewBuildId = import.meta.env.VITE_PREVIEW_BUILD_ID;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getStoredLocale(),
    fallbackLng: DEFAULT_LOCALE,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: previewBuildId ? `${translationPath}?v=${previewBuildId}` : translationPath,
    },
  });

export default i18n;
